module.exports = __webpack_public_path__ + "static/media/product_slide_1.2b97ca0e.png";